<div class="container mt-4" dir="rtl">
  <h3>وبلاگ</h3>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <!-- فیلد جستجو (اگر دارید، از حالت کامنت خارج کنید) -->
    <!-- <div class="flex-grow-1 me-3">
      <input type="text" class="form-control" placeholder="جستجو..." [(ngModel)]="searchTerm" (input)="onSearchInput()">
    </div> -->
    <div>
      <button class="btn btn-primary" (click)="openModal()">
        افزودن پست جدید
      </button>
    </div>
  </div>

  <!-- 🟪 نسخه موبایل: نمایش کارتی -->
  <!-- ❗ حلقه روی displayPosts قرار گرفته و قابلیت کلیک اضافه شده -->
  <div class="d-block d-md-none">
    <div *ngFor="let user of displayPosts; let i = index" class="card mb-3 shadow-sm" (click)="goToPostDetail(user.id)" style="cursor:pointer;">
      <div class="card-body">
        <h5 class="card-title fw-bold">{{ user.title }}</h5>
        <!-- ❗ استفاده از تابع getShortDescription برای خلاصه توضیحات -->
        <p class="card-text">{{ getShortDescription(user.description) }}</p>
        <h6 class="card-subtitle mb-2 text-muted">نوع: {{ user.wich_kind }}</h6>

        <div class="mt-2 text-end">
          <!-- ❗ $event.stopPropagation() برای جلوگیری از هدایت هنگام کلیک روی دکمه -->
          <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(user.id); $event.stopPropagation();">ویرایش</button>
          <button class="btn btn-danger btn-sm" (click)="delete(user.id); $event.stopPropagation();">حذف</button>
        </div>
      </div>
    </div>
    <!-- پیام در صورت عدم وجود پست -->
    <div *ngIf="displayPosts.length === 0" class="alert alert-info text-center" role="alert">
      پستی یافت نشد.
    </div>
  </div>

  <!-- 🟪 نسخه دسکتاپ: نمایش جدولی -->
  <!-- ❗ حلقه روی displayPosts قرار گرفته و قابلیت کلیک اضافه شده -->
  <div class="table-responsive d-none d-md-block">
    <table class="table table-bordered text-end custom-table">
      <thead class="custom-thead">
        <tr>
          <th>عنوان</th>
          <th>خلاصه توضیحات</th>
          <th>نوع</th>
          <th style="width: 20%;">عملیات</th>
        </tr>
      </thead>
      <tbody>
        <!-- ❗ حلقه روی displayPosts قرار گرفته و قابلیت کلیک اضافه شده -->
        <tr *ngFor="let user of displayPosts" (click)="goToPostDetail(user.id)" style="cursor:pointer;">
          <td>{{ user.title }}</td>

          <!-- ❗ استفاده از تابع getShortDescription برای خلاصه توضیحات -->
          <td>
            {{ getShortDescription(user.description) }}
          </td>

          <td>{{ user.wich_kind }}</td>
          <td>
            <!-- <button (click)="goToPostDetail(user.id)">مشاهده جزئیات</button> -->
            <!-- ❗ $event.stopPropagation() برای جلوگیری از هدایت هنگام کلیک روی دکمه -->
            <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(user.id); $event.stopPropagation();">ویرایش</button>
            <button class="btn btn-danger btn-sm" (click)="delete(user.id); $event.stopPropagation();">حذف</button>
          </td>
        </tr>
        <!-- پیام در صورت عدم وجود پست -->
        <tr *ngIf="displayPosts.length === 0">
          <td colspan="4" class="text-center alert alert-info" role="alert">
            پستی یافت نشد.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal Section (اگر هنوز از این مدال برای افزودن/ویرایش استفاده می‌کنید) -->
  <!-- نام متغیرها (anyObj, onSave, closeModal, openEditModal) باید با TypeScript شما مطابقت داشته باشد. -->
  <div class="modal fade" #userModal id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" dir="rtl">
        <div class="modal-header">
          <h5 class="modal-title" id="userModalLabel">
            {{ anyObj.id ? 'ویرایش پست' : 'افزودن پست جدید' }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()"
            aria-label="بستن"></button>
        </div>

        <div class="modal-body">
          <form id="userForm">
            <div class="row g-3">
              <div class="col-md-12 mb-3">
                <label class="form-label">عنوان پست</label>
                <input type="text" [(ngModel)]="anyObj.title" name="title" class="form-control"
                  placeholder="عنوان را وارد کنید">
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label">توضیحات</label>
                <textarea [(ngModel)]="anyObj.description" name="description" class="form-control" placeholder="توضیحات پست را وارد کنید" rows="4"></textarea>
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label">نوع پست</label>
                <input type="text" [(ngModel)]="anyObj.wich_kind" name="wich_kind" class="form-control" placeholder="نوع پست را وارد کنید">
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">بستن</button>
          <button type="button" (click)="onSave()" class="btn btn-success">
            {{ anyObj.id ? 'ذخیره تغییرات' : 'افزودن پست' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
